import { createReducer } from "typesafe-actions";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import ActivitiesLoggedCardConfiguration from "@app/types/dashboard/cards/activitiesLogged/ActivitiesLoggedCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  ActivitiesLoggedCardActions,
  applyActivitiesLoggedDrillDownListViewSettings,
  fetchActivitiesLoggedCardDrillDownData,
  hideActivitiesLoggedDrillDown,
  showActivitiesLoggedDrillDown,
} from "./actions";

export interface ActivitiesLoggedCardState {
  configuration?: ActivitiesLoggedCardConfiguration; // also works as a "visible" trigger, visible if set
  drillDownCustomDateRange?: DateRange;
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const activitiesLoggedInitialState: ActivitiesLoggedCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const activitiesLoggedState = createReducer<ActivitiesLoggedCardState, ActivitiesLoggedCardActions>(
  activitiesLoggedInitialState
)
  .handleAction(showActivitiesLoggedDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
    drillDownCustomDateRange: payload.customDateRange,
  }))
  .handleAction(showActivitiesLoggedDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideActivitiesLoggedDrillDown, (state) => ({
    ...state,
    configuration: undefined,
    drillDownCustomDateRange: undefined,
  }))
  .handleAction(fetchActivitiesLoggedCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchActivitiesLoggedCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchActivitiesLoggedCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyActivitiesLoggedDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default activitiesLoggedState;
